import type { AUTHENTICATION_TYPES } from 'node_modules/@seek/apac-candidate-header-footer/dist/types';

import type { AnalyticsEvents } from 'src/modules/analytics/analyticsEvents';
import { getAuthentication } from 'src/modules/authentication/authentication';

import { ANALYTICS_LOGIN_MESSAGE } from '../domain/constants';

interface AuthCheckOptions {
  authStatus: AUTHENTICATION_TYPES;
  returnPath?: string;
  openLoginDialog: (returnPath?: string) => void;
  trackAnalyticsInteraction?: (
    event: AnalyticsEvents,
    analyticsPayload?: object,
  ) => void;
}

export const handleAuthCheck = ({
  authStatus,
  returnPath,
  openLoginDialog,
  trackAnalyticsInteraction,
}: AuthCheckOptions): boolean => {
  if (authStatus !== 'authenticated') {
    openLoginDialog(returnPath);
    trackAnalyticsInteraction?.('LoginDialogDisplay', {
      message: ANALYTICS_LOGIN_MESSAGE,
    });
    return false;
  }
  return true;
};

export const getAuthStatus = async (): Promise<boolean> => {
  const isServer = typeof window === 'undefined';
  if (!isServer) {
    const authStatus = await getAuthentication();
    return authStatus.authenticationStatus === 'authenticated';
  }
  return false;
};
